import * as yup from 'yup';

import i18n from '@/config/i18n';
import { BaseYup, MAX_INPUT } from '@/config/baseYup';

export const planSearchFormSchema = BaseYup.object({
  keyword: BaseYup.string().max(MAX_INPUT),
  status: BaseYup.string().max(MAX_INPUT).nullable(),
  start_date: BaseYup.date().nullable(),
  end_date: BaseYup.date().nullable(),
});

export const planFormSchema = BaseYup.object({
  name: BaseYup.string().label(i18n.t('plan.plan_name')).required().max(MAX_INPUT),
  price: BaseYup.string()
    .label(i18n.t('plan.amount'))
    .required()
    .transform((value) => value.replace(/,/g, '')),
  student_limit: BaseYup.number()
    .required(i18n.t('plan.required.student_limit'))
    .min(10, i18n.t('plan.student_limit_min'))
    .max(1000, i18n.t('plan.student_limit_max'))
    .transform((value) => (Number.isNaN(value) ? null : value)),
});

export type PlanFormSearchType = yup.InferType<typeof planSearchFormSchema>;
export type PlanFormType = yup.InferType<typeof planFormSchema>;
